import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ProductWrapperDispatcher } from "./Variable";

export interface ProductWrapperStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ProductWrapperStatic extends BaseStore<ProductWrapperStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ProductWrapperDispatcher, (actionData) => this.onProductWrapperStoreResponse(actionData));
    }

    public getLastResult(): ProductWrapperStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ProductWrapperStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onProductWrapperStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
                case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
